import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularModule } from 'shared/modules/angular/angular.module';
import { MaterialModule } from 'shared/modules/material/material.module';
import { SearchComponent } from 'shared/modules/search/search/search.component';

@NgModule({
  declarations: [
    SearchComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    AngularModule,
  ],
  exports: [
    SearchComponent,
  ],
})
export class SearchModule {
}
